import { render, staticRenderFns } from "./BiReportTable.vue?vue&type=template&id=b45f3b74"
import script from "./BiReportTable.vue?vue&type=script&lang=js"
export * from "./BiReportTable.vue?vue&type=script&lang=js"
import style0 from "./BiReportTable.vue?vue&type=style&index=0&id=b45f3b74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports